import logo from "../../public/IMG_1579.JPG";

export function About() {
  return (
    <section className="mx-auto max-w-7xl px-6 py-20">
      <div className="grid gap-16 lg:grid-cols-[1.1fr_0.9fr] items-center">
        <div className="space-y-8">
          <h1 className="font-serif text-5xl text-foreground leading-tight">
            About <span className="italic text-primary">Miss T's</span>
          </h1>

          <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
            <p>
              Miss T's started from a simple love of baking — the kind that
              fills a home with warmth and brings people together. What began as
              treats for family and friends quickly grew into something more, as
              word spread about our homemade cookies, brownies, tiramisu, and
              cakes.
            </p>
            <p>
              Every item is baked fresh to order in small batches, using quality
              ingredients and recipes perfected over time. We believe dessert
              should feel special — whether it's a tray of brownies for a
              weeknight treat or a custom cake for a milestone celebration.
            </p>
          </div>
        </div>

        <div className="flex justify-center">
          <div className="relative w-full max-w-sm aspect-square rounded-3xl overflow-hidden border border-primary/20 shadow-2xl">
            <img
              src={logo}
              alt="Miss T's Home Bakery"
              className="size-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background/40 to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}
